// src/ui/layout/navbar/AsideNavMenu.jsx
import { useTranslations } from 'next-intl';
import { forwardRef } from 'react';

import { PATH } from '@/consts/path';
import useEscape from '@/hooks/key/useEscape';
import LazySpin from '@/utils/LazySpin';
import IntLink from '@/server/link/IntLink';

import styles from './styles.module.css';

const AsideNavMenu = forwardRef(({ isOpen, onClose }, ref) => {
  const t = useTranslations('nav');

  useEscape(onClose);
  return (
    <section className={`${styles.dropdown} ${isOpen ? styles.dropdownOpen : ''}`} ref={ref} aria-label='Menu de navigation latéral'>
      <nav className={styles.linkContainer} role='navigation'>
        {isOpen && (
          <LazySpin>
            <div className={styles.linkB} role='button'>
              <ul>
                <li>
                  <IntLink href={PATH.HOME} passHref>
                    <div aria-label={t('home')}>{t('home')}</div>
                  </IntLink>
                </li>
                <li>
                  <IntLink href={PATH.ABOUT} passHref>
                    <div aria-label={t('about')}>{t('about')}</div>
                  </IntLink>
                </li>
                <li>
                  <IntLink href={PATH.SERVICES} passHref>
                    <div aria-label={t('services')}>{t('services')}</div>
                  </IntLink>
                </li>
                <li>
                  <IntLink href={PATH.PROJECT} passHref>
                    <div aria-label={t('project')}>{t('project')}</div>
                  </IntLink>
                </li>
                <li>
                  <IntLink href={PATH.PARTNER} passHref>
                    <div aria-label={t('partners')}>{t('partners')}</div>
                  </IntLink>
                </li>
                <li>
                  <IntLink href={PATH.FAQ} passHref>
                    <div aria-label={t('faq')}>{t('faq')}</div>
                  </IntLink>
                </li>
                <li>
                  <IntLink href={PATH.SETTING} passHref>
                    <div aria-label={t('setting')}>{t('setting')}</div>
                  </IntLink>
                </li>
                <li>
                  <IntLink href={PATH.CONTACT} passHref>
                    <div aria-label={t('contact')}>{t('contact')}</div>
                  </IntLink>
                </li>
                <li>
                  <IntLink href={PATH.BLOG} passHref>
                    <div aria-label={t('blog')}>{t('blog')}</div>
                  </IntLink>
                </li>
                <li>
                  <IntLink href={PATH.NEWS} passHref>
                    <div aria-label={t('news')}>{t('news')}</div>
                  </IntLink>
                </li>
                <li>
                  <IntLink href={PATH.SUPPORT} passHref>
                    <div aria-label={t('support')}>{t('support')}</div>
                  </IntLink>
                </li>
              </ul>
            </div>
          </LazySpin>
        )}
      </nav>
    </section>
  );
});

AsideNavMenu.displayName = 'AsideNavMenu';
export default AsideNavMenu;
